// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Export = function Export(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#export-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.667 16.667c0 .305-.25.555-.556.555H2.222a.557.557 0 0 1-.555-.555V3.334c0-.306.25-.556.555-.556h5.556v2.778a1.11 1.11 0 0 0 1.11 1.11h2.779V10h1.666V6.476c0-.59-.232-1.156-.649-1.573L9.538 1.761a2.22 2.22 0 0 0-1.57-.65H2.223A2.224 2.224 0 0 0 0 3.334v13.333c0 1.226.997 2.222 2.222 2.222h8.89a2.224 2.224 0 0 0 2.221-2.222v-2.778h-1.666zm5.312-8.09a.833.833 0 0 0-1.177 1.177l1.354 1.354-9.656.003a.83.83 0 0 0-.833.834c0 .461.371.833.833.833h9.656l-1.354 1.354a.833.833 0 0 0 1.177 1.177l2.778-2.777a.83.83 0 0 0 0-1.178z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "export-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
